//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// eslint-disable-next-line import/named
import {
  SuperDate, compareDeepObject, debounce,
} from '@razlet/utils';

export default {
  name: 'base-datetime-picker',
  props: {
    id: {
      type: String,
      default: '',
    },
    value: {
      type: [Number, String, Object, Array],
      default: null,
    },
    from: {
      type: [Number, String, Object, Array],
      default: null,
    },
    to: {
      type: [Number, String, Object, Array],
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    errorText: {
      type: String,
      default: '',
    },
    dateBefore: {
      type: Object,
      default: null,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    isError: Boolean,
    required: Boolean,
    multiple: Boolean,
    disabled: Boolean,
    range: Boolean,
    withTime: Boolean,
    big: Boolean,
    showByWeekMode: Boolean,
  },
  data () {
    return {
      currentValue: { date: {} },
      debouncedInput: debounce(this.input, 400),
      byWeek: false,
    };
  },
  computed: {
    isDateBefore () {
      return this.dateBefore && this.dateBefore instanceof SuperDate;
    },
  },
  watch: {
    value: {
      handler (newValue, oldValue) {
        this.setCurrentValue(null, newValue, oldValue);
      },
      deep: true,
      immediate: true,
    },
    from: {
      handler (newValue, oldValue) {
        if (this.range) this.setCurrentValue('from', newValue, oldValue);
      },
      deep: true,
      immediate: true,
    },
    to: {
      handler (newValue, oldValue) {
        if (this.range) this.setCurrentValue('to', newValue, oldValue);
      },
      deep: true,
      immediate: true,
    },
    currentValue: {
      handler (value) {
        if (value && value.date && (!Object.keys(value.date).length || value.date.isValid)) {
          this.debouncedInput(value);
        }
      },
      deep: true,
    },
    dateBefore: {
      handler (value) {
        if (value && value instanceof SuperDate && value.client > this.value?.client) {
          this.setCurrentValue(null, null, this.value);
        }
      },
      deep: true,
    },
  },
  methods: {
    input (value) {
      if (this.range) {
        this.updateValue('update:from', value.date.from);
        this.updateValue('update:to', value.date.to);
      } else {
        this.updateValue('input', value.date);
      }
    },
    updateValue (emit, value) {
      this.$emit(emit, value && Object.keys(value).length
        ? this.withTime
          // eslint-disable-next-line vue/max-len
          ? new SuperDate(`${value.year}-${value.month.value}-${value.date}T${value.time.hours}:${value.time.minutes}:00`)
          : new SuperDate(`${value.year}-${value.month.value}-${value.date}`)
        : null
      );
    },
    checkNewValue (newValue, oldValue) {
      return newValue &&
        newValue instanceof SuperDate &&
        (
          !oldValue ||
          (
            oldValue instanceof SuperDate &&
            !compareDeepObject(newValue.toInput(this.withTime), oldValue.toInput(this.withTime))
          )
        );
    },
    setCurrentValue (field, newValue, oldValue) {
      if (this.range && this.checkNewValue(newValue, oldValue) && field) {
        this.$set(this.currentValue.date, field, newValue.toInput()?.date);
      } else if (!this.range && this.checkNewValue(newValue, oldValue)) {
        this.$set(this, 'currentValue', newValue.toInput(this.withTime));
      } else if (!newValue) {
        this.$set(this, 'currentValue', { date: {} });
      }
    },
  },
};
